import type { AppState } from '@store/types'
import { shallowEqual, useSelector } from 'react-redux'

import type { AuthState } from '@/types'

export const authSelector = (state: AppState) => state.auth

export const useAuth = () =>
  useSelector<AppState, AuthState>(authSelector, shallowEqual)
